function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.854 8.463L24.5 14l15.65-5.869a1 1 0 0 1 .7 0l15 5.59a1 1 0 0 1 .65.936v39.94a1 1 0 0 1-1.353.936L40.5 50l-15.65 5.869a1 1 0 0 1-.7 0l-15-5.594a1 1 0 0 1-.65-.937V9.398a1 1 0 0 1 1.354-.935zM24.5 14v42M40.5 8v42",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.5 23l8.5-3M24.5 29l8.5-3M24.5 35l8.5-3M24.5 41l8.5-3M24.5 47l8.5-3"
})));

function SvgMapAlt({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapAlt);
export default __webpack_public_path__ + "static/media/map-alt.4d3f691c.svg";
export { ForwardRef as ReactComponent };